/**
 * Constant used to convert a value to gamma space
 * @ignorenaming
 */
export var ToGammaSpace = 1 / 2.2;
/**
 * Constant used to convert a value to linear space
 * @ignorenaming
 */
export var ToLinearSpace = 2.2;
/**
 * Constant used to define the minimal number value in Babylon.js
 * @ignorenaming
 */
var Epsilon = 0.001;
export { Epsilon };
//# sourceMappingURL=math.constants.js.map